var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"},{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"button is-white loading",class:_vm.size,attrs:{"element-loading-spinner":"el-icon-loading","disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }